import type { IconProps } from './types';

export function Polo({ size = 24, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 256 256"
      fill="none"
      stroke="currentColor"
      strokeWidth="14"
      strokeLinejoin="round"
      strokeLinecap="round"
      {...props}
    >
      <path d="M76 92 Q88 88 96 92 L96 60 Q96 56 104 56 L152 56 Q160 56 160 60 L160 92 Q168 88 180 92 Q204 100 228 132 Q220 140 208 136 Q198 128 188 116 L188 208 Q188 216 180 216 L76 216 Q68 216 68 208 L68 116 Q58 128 48 136 Q36 140 28 132 Q52 100 76 92 Z" />
      <path d="M128 96 Q128 120 128 144" />
    </svg>
  );
}
